const AdminRole = ["Admin"];
const AdminAndUserRole = ["Admin", "User"];
const InternalRoles = ["CSM", "Ops"];
const ExternalRoles = ["Accounting", "Compliance", "Data", "FinancialExecutive", "Issuer", "ProgramManager"];
const AllInternalRoles = [...AdminAndUserRole, ...InternalRoles];
const AllExternalRoles = [...AdminAndUserRole, ...ExternalRoles];
const AllRoles = [...AdminAndUserRole, ...ExternalRoles, ...InternalRoles];

export { AllRoles, AdminRole, AdminAndUserRole, InternalRoles, ExternalRoles, AllExternalRoles, AllInternalRoles};